import { scroll } from "vendor";
/* ─── product-card-slider ───────────────────────────────────────────── */
var ProductCardSlider = class extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector(".product-card__slider-track");
    this._progressBar = this.querySelector(".product-card__progress-bar");
    if (!this._track || !this._progressBar) return;
    this._track.addEventListener("scroll", this._onScroll.bind(this), { passive: true });
  }
  _onScroll() {
    let track = this._track;
    let scrollLeft = track.scrollLeft;
    let maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 0) return;
    let mediaCount = parseInt(this.getAttribute("data-media-count")) || 1;
    let slideIndex = Math.round(scrollLeft / track.clientWidth);
    let translateX = slideIndex * 100;
    this._progressBar.style.transform = `translateX(${translateX}%)`;
  }
};
if (!window.customElements.get("product-card-slider")) {
  window.customElements.define("product-card-slider", ProductCardSlider);
}
